import { AddJewelryOptions } from "@utils/constants";

/**
 * Jewelry type / linkage filters carried over from a previous builder step.
 * After Change on Review, setting search is the first screen of a new flow
 * and these must not be reused.
 *
 * `additional_filters` is not stripped here. When enterSecondFlow is false,
 * getProcessedQueryParams is supposed to add them for setting search.
 */
export const JEWELRY_SETTING_FIRST_FLOW_FILTER_KEYS = [
  "jewelry_styles",
  "stock_item_ids",
  "is_center_size_selected",
  "searchForRing",
  "searchForPendant",
  AddJewelryOptions.ENGAGEMENT_RING,
  AddJewelryOptions.PENDANT,
  AddJewelryOptions.EARRINGS,
  "pendant",
  "earring",
] as const;

export function stripJewelryLinkageFromPayload<T extends Record<string, any>>(
  payload?: T | null
): T {
  if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
    return payload as T;
  }

  const stripped: Record<string, any> = { ...payload };

  JEWELRY_SETTING_FIRST_FLOW_FILTER_KEYS.forEach((key) => {
    delete stripped[key];
  });

  return stripped as T;
}

export function keepSettingSearchAdditionalFilters<
  T extends Record<string, any>
>(stripped: T, additionalFilters?: Record<string, any>): T {
  if (!additionalFilters || typeof additionalFilters !== "object") {
    return stripped;
  }

  const restored = { ...additionalFilters };
  delete restored.jewelry_styles;

  if (Object.keys(restored).length === 0) {
    return stripped;
  }

  return {
    ...stripped,
    additional_filters: restored,
  };
}
